import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {alto, codGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    height: '100%',
    backgroundColor: white,
  },
  headerText: {
    fontSize: 20,
    fontWeight: '700',
  },
  clearFiltersButton: {
    flexDirection: 'row',
    borderRadius: 8,
    marginTop: indent * 0.5,
    paddingHorizontal: indent * 0.8,
    paddingVertical: indent * 0.4,
    borderTopWidth: 1,
    borderColor: alto,
  },
  clearFilters: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: indent * 0.4,
  },
  clearBottoncontainer: {
    bottom: 20,
    backgroundColor: white,
    padding: 16,
    borderTopWidth: 1,
    borderColor: alto,
  },
  clearButton: {
    height: 40,
    borderColor: alto,
    borderRadius: 8,
    backgroundColor: white,
    justifyContent: 'center',
    borderWidth: 1,
  },
  buttonText: {
    color: codGray,
    fontSize: 14,
    textAlign: 'center',
  },
});
